import React, { Component } from 'react';
import { UncontrolledCollapse, Input, Badge, Container, ListGroup, ListGroupItem, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import product from '../../assets/img/product.png';
import { SvgAssets } from '../../assets/icons/iconSvg';
import { Bar, HorizontalBar } from 'react-chartjs-2';
import { Bubble } from 'react-chartjs-2';
import c from '../../constants/Colors';
import Spinner from "../reusable/Loader";
import faker from 'faker';


export class BonificacionGrafico extends Component {
  static displayName = BonificacionGrafico.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      dataTab: {},
      detalle: [],
      dataChart: {}
    };
  }

  reverseArray(array) {
    const arrayInverso = [];

    for (let i = array.length - 1; i >= 0; i--) {
      arrayInverso.push(array[i]);
    }

    return arrayInverso;
  }

  checkParams() {
    const { state } = this.props.location;

    const labels_char = [];
    const data_char = [];
    const data_char_montoM = [];
    console.log("params.detalle==> 2", state.detalle);

    state.detalle.sort(function (a, b) {
      if (a.monat > b.monat) {
        return 1;
      }
      if (a.monat < b.monat) {
        return -1;
      }
      return 0;
    });


    state.detalle.map((item, index) => {
      labels_char.push(item.nomMes);
      data_char.push(item.montoR);
      data_char_montoM.push(item.montoM);
    });

    const CHAR_DATA = {
      labels: labels_char,
      datasets: [
        {
          type: "line",
          label: 'Monto Meta',
          backgroundColor: 'hsla(0, 0%, 0%, 0)',
          borderColor: '#003591',
          borderWidth: 1,
          hoverBackgroundColor: '#003591',
          hoverBorderColor: '#003591',
          data: (data_char_montoM),
          tension: 0,
        },
        {
          type: "bar",
          label: 'Monto Real',
          backgroundColor: c.verdeClaro,
          borderColor: c.verdeClaro,
          borderWidth: 1,
          hoverBackgroundColor: c.verdeClaro,
          hoverBorderColor: c.verdeClaro,
          data: data_char
        }
      ]
    };

    this.setState({ dataTab: state.dataTab, detalle: state.detalle, dataChart: CHAR_DATA, loading: false });
  }
  componentDidMount() {
    window.scrollTo(0, 0)
    this.checkParams();
  }
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.location.state !== this.props.location.state) {
      this.checkParams();
    }
  }

  render() {
    const { loading, dataChart, dataTab, detalle } = this.state;
    // const dataBar = {
    //   labels: ['Ene', 'Feb', 'Set', 'Oct', 'Nov'],
    //   datasets: [
    //     {
    //       type: "bar",
    //       label: 'My First dataset',
    //       backgroundColor: '#EC932F',
    //       borderColor: 'rgba(255,99,132,1)',
    //       borderWidth: 1,
    //       hoverBackgroundColor: 'rgba(255,99,132,0.4)',
    //       hoverBorderColor: 'rgba(255,99,132,1)',
    //       data: [8.83, -304.21, 6421.23, 8000, 0]
    //     },
    //     {
    //       type: "line",
    //       label: 'My First dataset 2',
    //       backgroundColor: 'hsla(0, 0%, 0%, 0)',
    //       borderColor: 'rgba(255,99,132,1)',
    //       borderWidth: 1,
    //       hoverBackgroundColor: 'rgba(255,99,132,0.4)',
    //       hoverBorderColor: 'rgba(255,99,132,1)',
    //       data: [102000, 102000, 5000, 7000, 10000],
    //       fill: true
    //     }
    //   ]
    // };
    // debugger;



    return (
      <div>
        <Spinner visible={loading} />
        <div className="title_banner">
          <Container>
            <h1>Metas y Bonificaciones</h1>
          </Container>
          <SvgAssets icon="curve-top" className='curve-bottom' fill="#fff" />
        </div>
        <div className="breadcrumb">
          <Container>
            <ul>
              <li><Link to='/dashboard'>Dashboard</Link></li>
              <li><Link to='/bonificaciones'>Metas y Bonificaciones</Link></li>
              <li>Detalle</li>
            </ul>
          </Container>
        </div>
        <Container className="py-5">
          <h6 className="title white mobile px-5">
            <a onClick={() => this.props.history.goBack()} className='back'><SvgAssets icon="icon-arrow-left" fill={'#fff'} /></a>
            Metas y Bonificaciones
          </h6>
          <div className="card">
            <SvgAssets icon="curve-bottom" className='curve-top mobile' fill="#1B52B2" />
            <div className="estado-cuenta-date">
              <div className="content-left">
                <h5 className='paragraph-1 bold'>{dataTab.tituloMeta}</h5>
                <h1 className='title-2 bold mt-2' style={{ color: c.verdeClaro }}>{dataTab.sMontoM}</h1>
              </div>
              <div className="content-right">
                <span className='paragraph-2 light' style={{ color: c.azulClaro }}>{dataTab.sMontoR}</span>
                <span className='paragraph-2 light' style={{ color: c.verdeClaro }}>{dataTab.sPorCum}</span>
              </div>
            </div>
            <h6 className='paragraph-1 bold mb-5'>Gráfico de Barras</h6>
            <div className="container_680 card_desktop">
              {(detalle.length > 0) ?
                <>
                  <Bar
                    data={dataChart}
                    type="bar"
                    width={100}
                    height={60}
                  />

                  {/* <Bar
                    data={dataBar}
                    // data={dataChart}
                    type="bar"
                    width={100}
                    height={60}
                  /> */}

                </>



                : null}
            </div>
          </div>
        </Container>
      </div>
    );
  }
}
